/**
 * Small badge showing which chain a DID lives on. Chain-qualified DIDs
 * (did:adi:84532:0x…) resolve via the registry; bare wallet DIDs show the home
 * chain; key-based DIDs render nothing (chainless).
 */
import { useNetwork } from '../contexts/NetworkContext';

export default function ChainBadge({ did, className = '' }: { did: string; className?: string }) {
  const { chainForDID } = useNetwork();
  const chain = chainForDID(did);
  if (!chain) return null;
  return (
    <span
      title={`This DID's on-chain record lives on ${chain.name} (chain ${chain.chainId})`}
      className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-px text-[9px] font-bold uppercase tracking-wide ${
        chain.testnet ? 'border-amber-200 bg-amber-50 text-amber-700' : 'border-emerald-200 bg-emerald-50 text-emerald-700'
      } ${className}`}
    >
      <span className={`size-1.5 rounded-full ${chain.testnet ? 'bg-amber-400' : 'bg-emerald-500'}`}></span>
      {chain.shortName}
    </span>
  );
}
